import store_prestation from "@/store/mods/clinique/prestations"
import mod_prestation from "@/store/mods/clinique/prestations.js"

export default {
    name: 'm-consommable-bon',
    components: {},
    props: {
        user_id: Number,
        info_patient: Object,
        info_caissier: Object,
        refresh_state: Number,
        is_proforma: Boolean,
        proforma_id: Number,
        can_add_differential_computing: Object,
        format_ref_facture: String,
        selected_slug: String,
        patient_insurance_info: Object
    },
    data() {
        return {
            one_is_checked: [],
            save_loading: false,
            choice_is_empty: false,
            is_error: false,
            permission_is_denied: false,

            filter_consommable_bon: '',
            filtered_consommable_bons: [],
            selected_prestations: [],

            consumables_of_consultation: [],
            is_loading: true,
            is_empty: false
        }
    },
    
    watch: {
        filter_consommable_bon() {
            this.filterConsommableBon()
        },

        one_is_checked() {
            this.choice_is_empty = false
        },

        refresh_state() {
            if (this.selected_slug == 'consommable_bon') {
                this.fetchConsommableBon()
            }
        }
    },

    computed: {
        
    },

    mounted() {
        
    },

    methods: {
        hadleUndefinedPrice() {
            this.warningToast("Le prix de ce consommable de bon n'a pas été défini !")
        },

        fetchConsommableBon() {
            this.is_loading = true
            store_prestation.getConsumableOfConsultation({ hide_empty_price: 0 }).then((consumables_of_consultation) => {
                this.consumables_of_consultation = consumables_of_consultation
                this.filtered_consommable_bons = this.consumables_of_consultation

                if (this.filtered_consommable_bons.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_error = true
            })
        },

        submit() {
            if (this.one_is_checked.length == 0) {
                this.choice_is_empty = true
                return;
            }
            this.one_is_checked = this.setPrestationUID(this.one_is_checked)

            let data = {
                user_id: this.user_id,
                patient_id: this.info_patient.id,
                prestations: this.one_is_checked,
                type_prestation: 'Consommable de bon',
                data_type: 'consommable_bon',
                proforma_id: this.proforma_id,
                is_proforma: this.is_proforma,
                can_add_differential_computing: this.can_add_differential_computing.response,
                can_set_pac: this.can_set_pac,
                info_caissier: this.info_caissier,
                info_patient: {
                    nom_patient: this.info_patient.nom,
                    sexe: this.formatSexeMetier(this.info_patient.sexe),
                    telephone: this.info_patient.telephone_mobile,
                    num_dossier: this.info_patient.num_dossier,
                    age: this.info_patient.age
                },
                format_ref_facture: this.format_ref_facture
            }

            this.save_loading = true
            mod_prestation.getTarifPrestation(data).then((response) => {
                data = Object.assign(data, response)
                data.duree_forfait_hospi_est_expire = this.patient_insurance_info.duree_forfait_hospi_est_expire

                this.$store.dispatch('saveVentePrestation', data).then((response) => {
                    if (response.success) {
                        this.successToast('Ajout effectué avec succès')

                        this.$emit('emitPrestation', response.fpro_id)

                        this.one_is_checked = []
                        this.$refs.fpro_consommable_bon.click()

                        if (response.fpro_id > 0) {
                            this.$router.push({ path: '/ventes/facture-proforma/'+response.fpro_id })
                        }
                    } else {
                        this.$refs.fpro_consommable_bon.click()
                        this.dangerToast(response.message)
                    }

                    this.save_loading = false
                }).catch(() => {
                    this.save_loading = false
                    this.$refs.fpro_consommable_bon.click()
                    this.dangerToast('Une erreur est survenue lors de l\'enregistrement. Veuillez réessayer plus tard.')
                })
            }).catch(() => {
                this.save_loading = false
                this.$refs.fpro_consommable_bon.click()
                this.dangerToast('Une erreur est survenue lors du calcul des tarifs. Veuillez réessayer plus tard.')
            })
        },

        filterConsommableBon() {
            this.filtered_consommable_bons = [];

            if (this.filter_consommable_bon == '') {
                this.filtered_consommable_bons = this.consumables_of_consultation
            } else {
                this.consumables_of_consultation.forEach(consommable_bon => {
                    let cleaned_consommable_bon = this.removeAccents(consommable_bon.consumable_item)
                    let cleaned_filter = this.removeAccents(this.filter_consommable_bon)

                    if (cleaned_consommable_bon.toLowerCase().includes(cleaned_filter.toLowerCase())) {
                        this.filtered_consommable_bons.push(consommable_bon)
                    }
                });
            }
        },
    }
}
